<template>
  <div class="container">
    <div v-if="isPC">
      <div class="desc title">
        <h2>{{ $t('Home.Home.BestSellers') }}</h2>
      </div>
      <div class="desc subject">
        <p>{{ $t('Home.Home.BestSellersSubject') }}</p>
      </div>

      <div class="categroy">
        <ul>
          <li v-for="categroy in categroyList" :key="categroy.categoryId" @mouseenter="getItem(categroy)">
            <a v-if="categroy.name === categoryName" class="category_color" :href="'/product-list/' + categroy.categoryUrl" target="_blank">{{ categroy.name }}</a>
            <a v-else :href="'/product-list/' + categroy.categoryUrl" target="_blank">{{ categroy.name }}</a>
          </li>
        </ul>
      </div>
      <div>
        <el-carousel :autoplay="false" arrow="always" :height="productBoxHeight" :indicator-position="indicator">
          <el-carousel-item v-for="(items, index) in productList" :key="index">
            <div class="f-b banner-box" v-loading="listLoading">
              <div class="product-img p-r" v-for="item in items" :key="item.kkProductId" @click="jumpDetailSeo(item.kkProductId)">
                <oss-img :src="item.imgUrl || item.images" :width="252" :height="336" :isLazy="false" ref="ossImg" :alt="item.productName" />
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="mobiler-container" v-else>
      <div class="title">
        <h2>{{ $t('Home.Home.BestSellers') }}</h2>
      </div>
      <div class="subject">
        <p>{{ $t('Home.Home.BestSellersSubject') }}</p>
      </div>
      <div class="tab-wrapper" @touchstart="onTouchStart" @touchmove="onTouchMove">
        <div class="tab-content" :style="{ transform: 'translateX(' + offsetX + 'px)' }">
          <div v-for="categroy in categroyList" :key="categroy.categoryId" @mouseenter="getItem(categroy)" class="tab-item">
            <a v-if="categroy.name === categoryName" class="mobile-category_color" :href="'/product-list/' + categroy.categoryUrl" target="_blank">{{ categroy.name }}</a>
            <a v-else :href="'/product-list/' + categroy.categoryUrl" target="_blank">{{ categroy.name }}</a>
          </div>
        </div>
      </div>
      <div>
        <el-carousel :autoplay="false" arrow="always" :height="mobileProductBoxHeight" :indicator-position="indicator">
          <el-carousel-item v-for="(items, index) in productList" :key="index">
            <div class="f-b" v-loading="listLoading">
              <!-- <div class="product-item" ref="ossImg" v-for="item in items" :key="item.kkProductId">
              <a v-if="item.productSeoSearchTerm" :href="'/content/product-detail' + item.productSeoSearchTerm" target="_blank"><img class="product_image" :src="item.images" :alt="item.productName"/></a>
              <img v-else class="product_image" :src="item.images" :alt="item.productName" @click="isNull"/>
              <p class="ellipsis" :title="item.productName">
                <a v-if="item.productSeoSearchTerm" :href="'content/product-detail' + item.productSeoSearchTerm" target="_blank">{{ item.productName }}</a>
                <a v-else href="javascript:;" @click="isNull">{{ item.productName }}</a>
              </p>
              <p v-if="userId">WSP {{ currencySymbol }}{{item.price || item.minPrice | currencyConversion}}
                <span v-if="isPC&&showVolume&&!item.afterDiscountAmount" style="float: right;">{{item.salesVolume}} {{ $t('Components.Product.Sales') }}</span>
              </p>
              <p v-else>WSP <img class="lock" style="width:18px; margin-left: 4px;" src="@/assets/img/icon/lock.png" alt="">
                <span v-if="isPC&&showVolume&&!item.afterDiscountAmount" style="float: right;">{{item.salesVolume}} {{ $t('Components.Product.Sales') }}</span>
              </p>
              </div> -->
              <div v-for="item in items"  :key="item.kkProductId">
                <oss-img ref="ossImg" :src="item.imgUrl || item.images" :width="31" :height="42" class="product-img" style="border-radius:4px;" />
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'

export default {
  name: 'Banner',
  props: {
    showVolume: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      indicator: 'none',
      productBoxHeight: '349px',
      mobileProductBoxHeight: '83px',
      productList: [],
      categroyList: [],
      categoryName: '',
      listLoading: false,
      startX: 0,
      moveX: 0,
      offsetX: 0
    }
  },
  mounted() {
    window.onresize = () => {
      this.productBoxHeight = this.$refs.ossImg[0].clientHeight + 'px'
    }
  },
  created() {
    this.getItem({ categoryId: 21684 })
    this.categroy()
  },
  methods: {
    getItem(v) {
      let data = {
        'pageSize': 15,
        'pageNumber': 1,
        'materialArray': [],
        'minPrice': 0,
        'maxPrice': 200,
        'sortType': 'desc',
        'sortName': 3,
        'supplierLevels': [],
        'categoryId': v === undefined ? '' : v.categoryId
      }
      this.categoryName = v.name === undefined ? 'Men' : v.name
      this.listLoading = true
      API.getOpenProductList(data).then(({ data }) => {
        let key = -1
        this.productList = [[], [], []];
        (data.list || []).forEach((element, index) => {
          if (index % 5 === 0) key++
          this.productList[key].push(element)
        })
      }).finally(() => {
        this.listLoading = false
      })
    },
    categroy() {
      API.getCategoryList({
        pageSize: 100,
        pageNumber: 1,
        status: 1
      }).then((data) => {
        data.data.list.forEach((element, index) => {
          if (element.name !== 'Shoes' && element.name !== 'Private Design') {
            this.categroyList.push(element)
          }
        })
      }).finally(() => {
        this.listLoading = false
      })
    },
    countCurrencyConversion(value) {
      if (!value || typeof value !== 'number') return value
      let rate = this.$store.state.common.currencyRate * 10000
      return (value * 10000 * rate / 100000000).toFixed(2)
    },
    isNull() {
      return this.$message.warning(this.$t('Components.Product.DetailHint'))
    },
    onTouchStart(event) {
      this.startX = event.touches[0].clientX
    },
    onTouchMove(event) {
      this.moveX = event.touches[0].clientX - this.startX
      if (this.moveX < -2) {
        this.offsetX = this.moveX
      } else {
        this.offsetX = -2
      }
    },
    onTouchEnd() {
      // 可以根据偏移量来判断是否切换tab
    }
  },
  computed: {
    currencySymbol() {
      return this.$store.state.common.currencySymbol
    },
    userId() {
      return this.$store.state.common.userId
    }
  }
}
</script>

<style lang="scss" scoped>
.product-img {
  position: relative;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
}
/** 图片鼠标上移放大缩小 */
.product-single:hover .product-collection {
  display: flex !important;
}
.product-single:hover .product-img > img,
.product-single:hover .product-img /deep/ img {
  transition: transform 0.6s;
  transform: scale(1.3);
}
.product-img > img,
.product-img /deep/ img {
  transition: transform 0.6s;
}
.product-item {
  width: 19.2%;
  height: 460px;
  .product_image {
    width: 270px;
    height: 400px;
    border-radius: 20px 20px 0 0;
    object-fit: cover;
    cursor: pointer;
  }
  p {
    font-size: 16px;
    height: 28px;
    line-height: 28px;
    font-weight: 500;
  }
}
/deep/.el-carousel__arrow {
  color: #000000;
  font-weight: 800;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.14);
  border: none;
  top: 50%;
  [class^='el-icon-'] {
    font-weight: 1000;
  }
}
/deep/.el-carousel__arrow--left {
  left: 0px;
}
/deep/.el-carousel__arrow--right {
  right: 0px;
}
.desc {
  text-align: center;
  font-style: normal;
  letter-spacing: -0.02em;
}
.title h2 {
  font-family: Poppins, Poppins;
  font-weight: 600;
  font-size: 36px;
  color: #303133;
  line-height: 48px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-bottom: 16px;
}
.subject p {
  font-family: Poppins, Poppins;
  font-weight: 400;
  font-size: 16px;
  color: #303133;
  line-height: 24px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-bottom: 56px;
}
.categroy {
  height: 50px;
  line-height: 40px;
  margin-bottom: 14px;
}
.categroy ul {
  list-style: none;
  height: 40px;
  border-bottom: 1px solid #eff1f7;
}
.categroy ul li {
  float: left;
  padding-left: 20px;
  cursor: pointer;
}
a {
  font-family: Poppins, Poppins;
  font-weight: 400;
  font-size: 16px;
  color: #909399;
  // line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: inline-block;
  height: 40px;
}
.category_color {
  color: rgb(153, 196, 28) !important;
  border-bottom: 1px solid #9ac331;
}
.mobiler-container {
  padding: 0 20px;
  text-align: center;

  .title h2 {
    font-weight: 600;
    font-size: 20px;
    color: #303133;
    line-height: 28px;
    margin-bottom: 12px;
  }
  .subject p {
    font-weight: 400;
    font-size: 14px;
    color: #606266;
    line-height: 22px;
    margin-bottom: 32px;
  }
}
.mobile-category_color {
  color: rgb(153, 196, 28) !important;
}

.banner-box {
  height: 100%;
  > div {
    width: 19.2%;
    position: relative;
  }
}
.tab-wrapper {
  width: 100%;
  overflow: hidden;
}

.tab-content {
  width: 100%;
  white-space: nowrap;
  transition: transform 0.3s;
}

.tab-item {
  display: inline-block;
  padding: 10px;
  a {
    display: inline-block;
    height: 20px;
  }
}
</style>

